<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
      <el-form-item label="学员姓名" prop="username">
        <el-input v-model="ruleForm.username"></el-input>
      </el-form-item>
      <!-- <el-form-item label="上传头像" prop="avatar">
                <imgUpload v-model="ruleForm.avatar"></imgUpload>
            </el-form-item> -->
      <el-form-item label="性别" prop="sex">
        <el-select v-model="ruleForm.sex" placeholder="请选择活动区域">
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="政治面貌" prop="political_outlook">
        <el-select v-model="ruleForm.political_outlook" placeholder="请选择政治面貌">
          <el-option label="群众" value="群众"></el-option>
          <el-option label="党员" value="党员"></el-option>
          <el-option label="共青团员" value="共青团员"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="民族" prop="nation">
        <el-input v-model="ruleForm.nation"></el-input>
      </el-form-item>
      <el-form-item label="毕业学校" prop="school">
        <el-input v-model="ruleForm.school"></el-input>
      </el-form-item>
      <el-form-item label="专业" prop="major">
        <el-input v-model="ruleForm.major"></el-input>
      </el-form-item>
      <!-- <el-form-item label="地址" prop="area">
                <areaSelect v-model="ruleForm.area" @province="ruleForm.province=$event" @city="ruleForm.city=$event"></areaSelect>
            </el-form-item> -->
      <el-form-item label="籍贯" prop="native_place">
        <areaSelect
          v-model="native_place"
          @addr="ruleForm.native_place = $event"
          @area="ruleForm.area = $event"
          @province="ruleForm.province = $event"
          @city="ruleForm.city = $event"
        ></areaSelect>
      </el-form-item>
      <el-form-item label="家庭地址" prop="home_addr">
        <el-input v-model="ruleForm.home_addr"></el-input>
        <!-- <areaSelect v-model="home_addr" @addr="ruleForm.home_addr=$event"></areaSelect> -->
      </el-form-item>
      <el-form-item label="现居住地" prop="current_addr">
        <el-input v-model="ruleForm.current_addr"></el-input>
        <!-- <areaSelect v-model="current_addr" @addr="ruleForm.current_addr=$event"></areaSelect> -->
      </el-form-item>

      <el-form-item label="工作经历" prop="experience">
        <el-select v-model="ruleForm.experience" placeholder="请选择工作经历">
          <el-option label="育婴师" value="育婴师"></el-option>
          <el-option label="护理员" value="护理员"></el-option>
          <el-option label="收纳师" value="收纳师"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
        <!-- <el-input v-model="ruleForm.experience" placeholder="请输入工作经验"></el-input> -->
      </el-form-item>
      <el-form-item label="工作年限" prop="work_year">
        <el-input v-model="ruleForm.work_year"></el-input>
      </el-form-item>
      <el-form-item label="健康状况" prop="health_status">
        <el-select v-model="ruleForm.health_status" placeholder="请选择健康状况">
          <el-option label="健康" value="1"></el-option>
          <el-option label="有遗传病史" value="2"></el-option>
          <el-option label="有慢性病史" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件类型" prop="id_type">
        <el-select v-model="ruleForm.id_type" placeholder="请选择证件类型" disabled="disabled">
          <el-option label="身份证" :value="1"></el-option>
          <el-option label="驾驶证" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号" prop="id_no">
        <el-input v-model="ruleForm.id_no" @change="getVal"></el-input>
      </el-form-item>
      <el-form-item label="出生日期" prop="birthday">
        <el-date-picker
          v-model="ruleForm.birthday"
          type="date"
          placeholder="选择出生日期"
          value-format="yyyy-MM-dd"
          disabled="disabled"
        >
        </el-date-picker>
        <!-- <el-input v-model="ruleForm.age" placeholder="请输入年龄"></el-input> -->
      </el-form-item>
      <el-form-item label="学历" prop="education">
        <el-select v-model="ruleForm.education" placeholder="请选择学历">
          <el-option label="小学" value="小学"></el-option>
          <el-option label="初中" value="初中"></el-option>
          <el-option label="高中" value="高中"></el-option>
          <el-option label="大专" value="大专"></el-option>
          <el-option label="本科" value="本科"></el-option>
          <el-option label="研究生" value="研究生"></el-option>
          <el-option label="硕士" value="硕士"></el-option>
          <el-option label="博士" value="博士"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="手机" prop="mobile">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="ruleForm.email"></el-input>
      </el-form-item>
      <el-form-item label="紧急联系人" prop="emergency_contact">
        <el-input v-model="ruleForm.emergency_contact"></el-input>
      </el-form-item>
      <el-form-item label="紧急联系人电话" prop="emergency_phone">
        <el-input v-model="ruleForm.emergency_phone"></el-input>
      </el-form-item>
      <el-form-item label="爱好" prop="specialty">
        <el-input v-model="ruleForm.specialty"></el-input>
      </el-form-item>
      <el-form-item label="所属机构" prop="schoole_uuid">
        <el-select v-model="ruleForm.schoole_uuid" placeholder="请选择" filterable>
          <el-option v-for="item in schooleList" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
        </el-select>
      </el-form-item>
      <div style="width: 100%; text-align: center">
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import areaSelect from "@/components/pub/areaSelectName.vue";
import { addStuList, editStudent } from "@/api/student.js";
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import { getSchoolList } from "@/api/school.js";

export default {
  components: {
    areaSelect,
    imgUpload,
  },
  data() {
    const idCardValidity = (rule, code, callback) => {
      var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 ",
      };
      var tip = "";
      var pass = true;
      if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误";
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        // tip = "地址编码错误"
        tip = "身份证输入错误";
        pass = false;
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split("");
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          // 校验位
          var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
          var sum = 0;
          var ai = 0;
          var wi = 0;
          for (var i = 0; i < 17; i++) {
            ai = code[i];
            wi = factor[i];
            sum += ai * wi;
          }
          var last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            // tip = "校验位错误"
            tip = "身份证输入错误";
            pass = false;
          }
        }
      }
      if (!pass) {
        callback(new Error(tip));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        id_type: 1,
      },
      native_place: [],
      current_addr: [],
      home_addr: [],
      rules: {
        username: [
          {
            required: true,
            message: "请输入学员姓名",
            trigger: "blur",
          },
        ],
        mobile: [{ required: true, message: "请输入手机", trigger: "blur" }],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        // birthday: [
        //   {
        //     required: true,
        //     message: "请选择出生日期",
        //     trigger: "change",
        //   },
        // ],
        // work_year: [
        //   {
        //     required: true,
        //     message: "请填写工作年限",
        //     trigger: "blur",
        //   },
        // ],
        // health_status: [
        //   {
        //     required: true,
        //     message: "请选择健康状况",
        //     trigger: "change",
        //   },
        // ],
        // education: [
        //   {
        //     required: true,
        //     message: "请选择学历",
        //     trigger: "change",
        //   },
        // ],
        // native_place: [
        //   {
        //     required: true,
        //     message: "请选择籍贯",
        //     trigger: "change",
        //   },
        // ],
        // home_addr: [
        //   {
        //     required: true,
        //     message: "请选择家庭地址",
        //     trigger: "change",
        //   },
        // ],
        // current_addr: [
        //   {
        //     required: true,
        //     message: "请选择现居住地",
        //     trigger: "change",
        //   },
        // ],
        // major: [{ required: true, message: "请填写专业", trigger: "blur" }],
        // email: [{ required: true, message: "请填写邮箱", trigger: "blur" }],
        // emergency_contact: [
        //   {
        //     required: true,
        //     message: "请填写紧急联系人",
        //     trigger: "blur",
        //   },
        // ],
        // emergency_phone: [
        //   {
        //     required: true,
        //     message: "请填写紧急联系人电话",
        //     trigger: "blur",
        //   },
        // ],
        // school: [
        //   {
        //     required: true,
        //     message: "填写毕业学校",
        //     trigger: "blur",
        //   },
        // ],
        id_type: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "change",
          },
        ],
        // id_no: [{ required: true, message: '填写证件号', trigger: 'blur' }],

        id_no: [
          {
            required: true,
            message: "请输入证件号",
            trigger: "blur",
          },
          {
            pattern:
              /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: "请输入正确的证件号",
            trigger: "blur",
          },
          { validator: idCardValidity, trigger: "blur" },
        ],

        // nation: [{ required: true, message: "填写名族", trigger: "blur" }],
        // political_outlook: [
        //   {
        //     required: true,
        //     message: "请选择政治面貌",
        //     trigger: "change",
        //   },
        // ],
        // experience: [
        //   {
        //     required: true,
        //     message: "请选择工作经历",
        //     trigger: "change",
        //   },
        // ],
      },
      schooleList: [], // 机构列表
    };
  },
  mounted() {
    const query = this.$route.query;
    query.id_type = 1;
    if (query.id_no && query.id_no.length == 18 && !query.birthday) {
      const val = query.id_no;
      const year = val.substr(6, 4);
      const mon = val.substr(10, 2);
      const day = val.substr(12, 2);
      console.log(mon, day, year);
      query.birthday = year + "-" + mon + "-" + day;
    }
    this.ruleForm = query;

    if (query.native_place) {
      this.native_place = query.native_place.split(" ");
    }
    // if (query.home_addr) {
    //     this.home_addr = query.home_addr.split(' ')
    // }
    // if (query.current_addr) {
    //     this.current_addr = query.current_addr.split(' ')
    // }
    console.log(this.current_addr);
    if (query.id) {
    }

    this.getSchooleList();
  },
  methods: {
    // 获取机构列表
    async getSchooleList() {
      const res = await getSchoolList({
        page_size: 999,
        page_index: 1,
        status: 1,
      });
      this.schooleList = res.data ? res.data : [];
    },
    getVal(val) {
      if (val && val.length == 18) {
        const year = val.substr(6, 4);
        const mon = val.substr(10, 2);
        const day = val.substr(12, 2);
        console.log(mon, day, year);
        this.ruleForm = {
          ...this.ruleForm,
          birthday: year + "-" + mon + "-" + day,
        };
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.id) {
            this.editSub();
          } else {
            this.addSub();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSub() {
      addStuList(this.ruleForm).then((res) => {
        if (res == true) {
          this.$message.success("成功");
          this.$router.go(-1);
        }
      });
    },
    editSub() {
      editStudent(this.ruleForm, this.ruleForm.id).then((res) => {
        if (res == true) {
          this.$message.success("成功");
          this.$router.go(-1);
        }
      });
    },
    resetForm(formName) {
      this.$router.go(-1);
      // this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.el-input,
.el-select {
  width: 250px;
}
.demo-ruleForm {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-cascader {
    width: 250px;
  }
  .el-form-item {
    width: 45%;
  }
}
</style>
